import React, { ChangeEvent } from "react";
import { QuestionInput } from "../../../../../__generated__/gql-types/globalTypes";
import { Col, Row } from "antd";
// import styles from "../../quizzForm.module.css";
import styles from "./dad.module.css";
import { ErrorMessage, Field } from "formik";
import { BlocksComponent } from "./BlocksComponent";

interface DragAndDropQuestionProps {
  index: number;
  question: QuestionInput;
  handleChange: (
    e: React.ChangeEvent<HTMLInputElement>,
    index?: number
  ) => void;
  loadingLoadImage: boolean;
  setLoadingLoadImage: React.Dispatch<React.SetStateAction<boolean>>;
  urlImageQuestion: string;
  setUrlImageQuestion: React.Dispatch<React.SetStateAction<string>>;
  handleImageQuestion: (newImage: string) => void;
  handleAddBlockDADWithImage: () => void;
  handleRemoveBlockDADWithImage: () => void;
  fileImageBlockItems: string[];
  setFileImageBlockItems: React.Dispatch<React.SetStateAction<string[]>>;
  fileImageBlockContainer: string[];
  setFileImageBlockContainer: React.Dispatch<React.SetStateAction<string[]>>;
  handleImageDADQuestionRelationWithImage: (image: string, index: number) => void
}

export const DragAndDropQuestion = ({
  index,
  question,
  loadingLoadImage,
  urlImageQuestion,
  handleChange,
  handleImageQuestion,
  setLoadingLoadImage,
  setUrlImageQuestion,
  handleAddBlockDADWithImage,
  handleRemoveBlockDADWithImage,
  fileImageBlockItems,
  setFileImageBlockItems,
  fileImageBlockContainer,
  setFileImageBlockContainer,
  handleImageDADQuestionRelationWithImage
}: DragAndDropQuestionProps) => {
  return (
    <Col
      key={`${index}_${new Date()}`}
      style={{
        backgroundColor: "#E6E7EF",
        borderRadius: 20,
        paddingRight: 30,
        paddingLeft: 30,
        paddingTop: 10,
      }}
    >
      <div style={{ marginBottom: 10, marginTop: 5 }}>
        <label htmlFor={`questions_${index}`}>Pregunta {index}</label>
      </div>
      <Row>
        <Field
          id={`questions_${index}`}
          name="question"
          type="text"
          className={styles.formFieldSelect}
          defaultValue={question?.question ?? ""}
          onChange={(event: ChangeEvent<HTMLInputElement>) => {
            handleChange(event, index);
          }}
        ></Field>
        <ErrorMessage
          name="question"
          component="div"
          className={styles.error}
        />
      </Row>
      {question.dAndDQuestion?.map((dadQuestion, indexDADQuestion) => {
        return (
          <BlocksComponent
            dadQuestion={dadQuestion}
            indexDADQuestion={indexDADQuestion}
            handleChange={handleChange}
            handleAddBlockDADWithImage={handleAddBlockDADWithImage}
            handleRemoveBlockDADWithImage={handleRemoveBlockDADWithImage}
            fileImageBlockItems={fileImageBlockItems}
            setFileImageBlockItems={setFileImageBlockItems}
            fileImageBlockContainer={fileImageBlockContainer}
            setFileImageBlockContainer={setFileImageBlockContainer}
            handleImageDADQuestionRelationWithImage={handleImageDADQuestionRelationWithImage}
          />
        );
      })}
    </Col>
  );
};
